import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'
import { ConfigurationType } from '@/app/constants/configuration/configurationType'
import { toast } from '@/lib/toasts/api'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

// Toaster renderuje `text` doslownie - klucze trzeba przetlumaczyc TUTAJ.
const serverMessage = (error: unknown): string | undefined => {
  const data = (error as { response?: { data?: unknown } })?.response?.data
  if (typeof data === 'string') return data || undefined
  const message = (data as { message?: unknown })?.message
  return typeof message === 'string' && message.trim() ? message : undefined
}

/**
 * Przywraca stawki placy minimalnej z seedera. Pusty `country` = wszystkie kraje.
 * Zapis idzie do bazy od razu - nie ma "cofnij".
 */
export function useMinimumWageRestoreMutation(companyId: string) {
  const queryClient = useQueryClient()
  const { t } = useLocalize()

  return useMutation({
    mutationFn: async (country?: string) => {
      const { data } = await axiosInstance.post(
        `/api/${companyId}/configuration/restoreDefaultConfiguration`,
        { configurationType: ConfigurationType.MinimumWages, country },
      )
      return data
    },

    onError: (error) => {
      console.error('Error restoring minimum wage configuration:', error)
      toast.error({
        title: t('configuration.minimumWages.restoreError').toString(),
        text: serverMessage(error),
        autoCloseMs: 8000,
      })
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['configuration.minimumWage', companyId],
      })
      toast.success({
        title: t('configuration.minimumWages.restoredTitle').toString(),
        text: t('configuration.minimumWages.restoredDetails').toString(),
      })
    },
  })
}
